import { render, staticRenderFns } from "./BikesItem.vue?vue&type=template&id=21560eb6&lang=pug&"
import script from "./BikesItem.vue?vue&type=script&lang=js&"
export * from "./BikesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports